import React from 'react';
import WbAppLogo from '@sonifi/wb-sonifi-flat-theme/components/WbAppLogo';
import { NAV_KEYS } from '../constants/wbNavConstants';
import ProductsNav from './ProductsNav';
import { useWbNav } from '../hooks/useWbNav';

const WbNav = ({ primaryNav, secondaryNav, tertiaryNav }) => {
  const {
    authenticated,
    tabs,
    primaryNavState,
    secondaryNavState,
    onPrimaryNavClick,
    onSecondaryNavClick,
  } = useWbNav({ primaryNav, secondaryNav });

  return (
    <>
      <WbAppLogo onGoHome={() => {}} />
      <nav className="primary-nav">
        {authenticated ? (
          <div>
            <ul className="nav nav-tabs" role="tablist">
              {tabs.map((tab) => (
                <li
                  key={tab.key}
                  className={tab?.key === primaryNavState?.key ? 'active' : ''}
                  role="presentation"
                >
                  <a
                    role="tab"
                    data-toggle="tab"
                    onClick={() => {
                      onPrimaryNavClick(tab);
                    }}
                  >
                    {tab.title}
                  </a>
                </li>
              ))}
            </ul>
            <div className="tab-content">
              {primaryNavState ? (
                <div
                  id={primaryNavState.id}
                  key={primaryNavState.key}
                  className="tab-pane active"
                >
                  <div>
                    {primaryNavState.key === NAV_KEYS.products ? (
                      <ProductsNav
                        secondaryNav={secondaryNav}
                        tertiaryNav={tertiaryNav}
                      />
                    ) : (
                      <ul className="nav nav-tabs" role="tablist">
                        {primaryNavState.navChildren.map((nv, i) => (
                          <li
                            key={`${nv.key}${i}`}
                            className={
                              nv.key === secondaryNavState?.key ? 'active' : ''
                            }
                            role="presentation"
                          >
                            <a
                              role="tab"
                              data-toggle="tab"
                              onClick={() => onSecondaryNavClick(nv)}
                            >
                              {nv.title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </nav>
    </>
  );
};

export default WbNav;
